export default "__VITE_ASSET__BVrj2BwW__"